import { httpClient, HttpMethod } from './http-client';

export const getPartTypeCategories = (): any => {
  return httpClient('/partTypeCategories', HttpMethod.Get, null);
};